// tslint:disable

import * as React from 'react';
import { Field } from '../libs/form.lib';
import { ValidatorComponent } from '../libs/validator.component';
import { Validator } from '../libs/Validators';
import { ResourceModal } from '../structurals/resource-modal';
import { get } from 'lodash';
import { MetadataReaderLib } from '../../components/libs/metadata-reader.lib';
import './contentBuilder.scss';

declare const $: any;

export interface WysiwygFieldPropInterface {
    className?: string;
    title?: string;
    placeholder?: string;
    property?: string;
    validators?: Validator[];
    field: Field;
    onChange?: (value: any) => void;
    customMenu?: any,
    height?: number
}

export class ContentBuilderField extends React.Component<WysiwygFieldPropInterface> {
    public field: Field = this.props.field;
    public height: any = this.props.height;
    public uid: string = 'wwf' + Math.floor(Math.random() * 10000000);

    public meta = new MetadataReaderLib(null);

    public state: any = {
        error: null,
        mediaModalPlacement: null,
        customMenu: null
    };

    componentDidMount() {


        this.field.registerField();

        this.setBuilder();

        this.setClick();

        $('#' + this.uid).bind('DOMNodeInserted DOMNodeRemoved DOMSubtreeModified', () => {
            this.field.setValue($('#' + this.uid).data('contentbuilder').html(), false, false);
            this.setClick();
        })


        if (this.props.customMenu) {
            this.setState({customMenu: this.props.customMenu})
        }
        if (this.props.validators) {
            this.props.validators.forEach((v: Validator) => this.field.addValidator(v));
        }

        this.field.onValueChanges$.subscribe((value: any) => {
            if (this.props.onChange) {
                this.props.onChange(value);
            }
            this.field.onValidate$.next();
            this.setViewValue(value);
        });

        if (this.field.value && this.field.registered) {
            this.setViewValue(this.field.value);
        } else {
            this.setViewValue("");
        }


    }

    private setClick() {
        if ($('#' + this.uid).is(':empty')) {
            $('#' + this.uid).bind('click', () => {
                $('#lnkToolOpen').trigger('click');
            });
        } else {
            $('#' + this.uid).unbind('click');
        }
    }

    public setViewValue(value: any) {
        //$('#' + this.uid).html(value || '')
        $('#' + this.uid).data('contentbuilder').loadHTML(this.field.value);

        // console.log($('#' + this.uid).data('contentbuilder').html());


    }

    private setBuilder() {
        $('#' + this.uid).contentbuilder({
            snippetFile: "//" + location.host + '/assets/jmg/_snippets.html',
            toolbar: 'top',
            iconselect: "//" + location.host + '/assets/ionicons/selecticon.html',
            imageEmbed: false,
            snippetCategories: [
                [0, "Default"],
                [-1, "All"],
                [5, "Heading, Paragraph"],
                [6, "Paragraph"],
                [7, "Paragraph, Images + Caption"],
                [11, "Images"],
                [14, "List"],
                [15, "Quotes"],
                [20, "Video"],
                [100, "Custom Code"],
                [101, "Interview"],
                [40, "Include HTML"]
            ],
            buttons: ["bold", "italic", "formatting", "formatPara", "align", "list", "image", "table", "createLink", "unlink", "icon", "tags", "removeFormat", "html"],
            imageselect: () => {
                const element = React.createElement(ResourceModal, {
                    entity: 'file-manager',
                    config: {
                        multi: false,
                        defaultOpen: true,
                        onSelectSuccessful: (mediaItem: any) => {
                            $('#txtImgUrl').val(get(mediaItem[0], 'images.original'));
                            $('#txtImgUrl_rte').val(get(mediaItem[0], 'images.original'));
                            this.setState({mediaModalPlacement: null});
                        },
                    },
                });
                this.setState({mediaModalPlacement: element});
            }
        });
    }

    render() {
        return (
            <div className='w-100 relative form-group'>

                <label>{this.props.title || this.field.title || ''}</label>
                <div id={this.uid} className={`is-container container-fluid ${this.meta.site.code.toLowerCase()}_contentBuilder`}/>

                <ValidatorComponent field={this.field}/>

                {this.state.mediaModalPlacement}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/fields/contentBuilder.field.tsx